import { html } from 'lit';
import { PauseCircle } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-pause-circle')
export class PdsIconPauseCircle extends PdsIcon {
  @state()
  icon = PauseCircle;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
